import { useContext, useEffect } from 'react';
import styled, { css } from 'styled-components';

import {
  createNrkSaveUrl,
  NRKEmbedConfig,
} from '../../../utils/parsePastedVideoEmbedUrl';
import { MaxSizeMediaContentContext } from '../MaxSizeMediaContent/MaxSizeMediaContent';

const NrkViewer = ({
  nrkId,
  onLoad,
  disabledMedia,
}: {
  nrkId: string;
  onLoad?: (url: string) => void;
  disabledMedia: boolean;
}) => {
  const { height } = useContext(MaxSizeMediaContentContext);

  useEffect(() => {
    const script = document.createElement('script');

    script.src = NRKEmbedConfig.scriptUrl;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [nrkId]);

  useEffect(() => {
    nrkId && onLoad && onLoad(createNrkSaveUrl(nrkId));
  }, [onLoad, nrkId]);
  return (
    <NrkContainer key={nrkId} $disabledMedia={disabledMedia} $height={height}>
      <div className={NRKEmbedConfig.className} data-nrk-id={nrkId} />
    </NrkContainer>
  );
};

const NrkContainer = styled.div<{ $disabledMedia: boolean; $height?: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: auto;
  height: 200px;
  border-radius: 10px;
  overflow: hidden;
  ${({ $height }) =>
    $height &&
    css`
      height: ${$height}px;
      width: ${$height * (16 / 9)}px;
    `}


  iframe {
    aspect-ratio: 16/9;
    ${({ $height }) =>
      $height &&
      css`
        height: ${$height}px;
      `}
    overflow: ${({ $disabledMedia }) => (!$disabledMedia ? 'auto' : 'hidden')};
    pointer-events: ${({ $disabledMedia }) => (!$disabledMedia ? 'auto' : 'none')};
  }

`;

export default NrkViewer;
